module.exports = __webpack_public_path__ + "img/Award2.af7f0924.jpg";